var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4062_8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14,
    stroke: "#71B3DE",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6874 24.1122C12.7244 24.3343 12.9187 24.5008 13.1499 24.5008H16.8501C17.0813 24.5008 17.2756 24.3343 17.3126 24.1122L17.6549 21.6609C18.2376 21.4296 18.7372 21.1151 19.2182 20.7544L21.5215 21.6794C21.725 21.7626 21.9748 21.6794 22.0858 21.4759L23.9359 18.2753C24.0561 18.0717 24.0006 17.822 23.8249 17.6832L21.873 16.1754L21.9378 15.2504L21.873 14.3253L23.8249 12.8175C24.0006 12.6788 24.0561 12.429 23.9359 12.2255L22.0858 9.02487C21.9748 8.82137 21.725 8.73811 21.5215 8.82137L19.2182 9.7464C18.7372 9.38564 18.2376 9.07113 17.6549 8.83987L17.3126 6.38852C17.2756 6.16651 17.0813 6 16.8501 6H13.1499C12.9187 6 12.7244 6.16651 12.6874 6.38852L12.3451 8.83987C11.7624 9.07113 11.2628 9.38564 10.7818 9.7464L8.47848 8.82137C8.27497 8.73811 8.02521 8.82137 7.91421 9.02487L6.06413 12.2255C5.94388 12.429 5.99938 12.6788 6.17514 12.8175L8.12697 14.3253L8.06222 15.2504L8.12697 16.1477L6.17514 17.6832C5.99938 17.822 5.94388 18.0717 6.06413 18.2753L7.91421 21.4759C8.02521 21.6794 8.27497 21.7534 8.47848 21.6794L10.7818 20.7451C11.2628 21.1151 11.7624 21.4296 12.3451 21.6609L12.6874 24.1122Z",
    stroke: "#71B3DE",
    strokeWidth: 1.75,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 18.3028C16.6859 18.3028 18.0526 16.9361 18.0526 15.2501C18.0526 13.5642 16.6859 12.1975 15 12.1975C13.314 12.1975 11.9473 13.5642 11.9473 15.2501C11.9473 16.9361 13.314 18.3028 15 18.3028Z",
    stroke: "#71B3DE",
    strokeWidth: 1.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4062_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingLight);
export default __webpack_public_path__ + "static/media/Setting_light.2b93960daa5be2c818664121cfb68463.svg";
export { ForwardRef as ReactComponent };